export class RegExpService {

  /** ============== IMPORTANT NOTE =============================
   *  If you want to use regex from ChatGPT or other sources like '^(?!$)\d+(\.\d+)?$' add additionally `\` to each slash
   *  and use ^(?!$)\\d+(\\.\\d+)?$ instead
   *  ===========================================================
   */

  static email = /^$|^[\w-\.]+@([\w-]+\.)+[\w-]{2,}$/;

  /**
   * Phone validation - requires at least one character
   * Plus only at beginning OR starts with digit
   */
  static phone = '^\\+[0-9\\s\\-()]+$|^[0-9][0-9\\s\\-()]+$';



  /*
  * same as positiveNumbersOnly previous just including zero
  */
  static positiveNumbersOnlyIncludeZero = '^(\\d*[0-9]+\\d*)$';

  static positiveNumbersOnlyOrEmpty = '^(\\d*[0-9]+\\d*)?$';

  /**
   * any integer number _OR_ empty digit
   * valid:
   * '', '-3000', '3000';
   * invalid:
   * '1.1', '111x', '-'.
   */
  static integerOrNull = '^(-?(\\d*)|(\\d*))$';

  static dateAsString$ = /^\d{4}-\d{2}-\d{2}$/;

  /**
   * any decimal number _OR_ empty digit
   * valid:
   * '', '3.44', '5', '1.';
   * invalid:
   * '111x', '-', '-17', '-1.2', '.7', '1.22.'
   */
  static partialNotNegativeDecimalNumbersOrEmpty = '^(?!$)\\d+(\\.\\d*)?$';
  /**
   * Same as {@link partialNotNegativeDecimalNumbersOrEmpty}, but this one does NOT allow
   * unfinished values like '1.'
   */
  static notNegativeDecimalNumbersOrEmpty = '^(?!$)\\d+(\\.\\d+)?$';

  /**
   * Date separated by slashes:
   * valid:
   * '1/1/2024', '01/1/2024', '1/01/2024', '01/01/2024';
   * invalid:
   * '1.1.2024', '1/1/24'
   */
  static dateSeparatedBySlashes = /^\d{1,2}\/\d{1,2}\/\d{4}$/;

  static hasLetters = /[a-zA-Z]+/;

  static uuidV4 = /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i;
}
